var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals"},[_c('transition-group',{attrs:{"tag":"div"}},_vm._l((_vm.modals),function(modal,index){return _c('Modal',_vm._b({key:index,attrs:{"id":modal.id,"clickHandler":modal.onClick},on:{"close":_vm.removeModal}},'Modal',modal,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }